import { useState, useEffect, useCallback } from 'react';

type ThemeMode = 'light' | 'dark' | 'system';

export function useTheme() {
  const [mode, setMode] = useState<ThemeMode>(() => {
    const stored = localStorage.getItem('chronomap-theme');
    if (stored === 'dark' || stored === 'light') return stored;
    return 'system';
  });

  // Track actual dark state for reactivity
  const [isDark, setIsDark] = useState(() =>
    typeof document !== 'undefined' && document.documentElement.classList.contains('dark')
  );

  const applyTheme = useCallback((m: ThemeMode) => {
    const root = document.documentElement;
    let dark: boolean;
    if (m === 'system') {
      localStorage.removeItem('chronomap-theme');
      dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    } else {
      localStorage.setItem('chronomap-theme', m);
      dark = m === 'dark';
    }
    root.classList.toggle('dark', dark);
    setIsDark(dark);
  }, []);

  useEffect(() => {
    applyTheme(mode);
  }, [mode, applyTheme]);

  const toggle = useCallback(() => {
    setMode(document.documentElement.classList.contains('dark') ? 'light' : 'dark');
  }, []);

  return { mode, setMode, toggle, isDark };
}
